
import { defineComponent, ref } from 'vue'
import { axiosSetting } from '@/utils/axiosSetting'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import SearchConditionCard from '@/components/block/SearchConditionCard.vue'
import Alert from '@/components/elements/Alert.vue'
import Loader from '@/components/elements/Loader.vue'

interface SearchCondition {
  id: string
  search_history: { [key: string]: any }
  search_label: { [key: string]: any }
}

export default defineComponent({
  components: {
    HeadingLv3,
    SearchConditionCard,
    Alert,
    Loader
  },

  props: {
    showCount: {
      type: Number,
      default: 3
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const isError = ref(false)
    const isLoading = ref(true)
    const ajax = axiosSetting('app', 'block')
    const searchHistoryHospital = ref<SearchCondition[]>([])
    const searchHistoryLatter = ref<SearchCondition[]>([])
    ;(async () => {
      const promise = []
      promise[0] = ajax
        .get(`/api/v1/search_history?col_count=${props.showCount}`)
        .then((res) => res.data.search_data)
      promise[1] = ajax
        .get(`/api/v1/s_search_history?col_count=${props.showCount}`)
        .then((res) => res.data.search_data)

      await Promise.all(promise)
        .then((data: SearchCondition[][]) => {
          isLoading.value = false
          searchHistoryHospital.value = data[0]
          searchHistoryLatter.value = data[1]
        })
        .catch(() => (isError.value = true))
    })()

    const deleteCondition = (payload: { index: number; type: string }) => {
      if (payload.type === 'hospital') {
        searchHistoryHospital.value.splice(payload.index, 1)
      }
      if (payload.type === 'latter') {
        searchHistoryLatter.value.splice(payload.index, 1)
      }
    }

    return {
      isError,
      isLoading,
      searchHistoryHospital,
      searchHistoryLatter,
      deleteCondition
    }
  }
})
